import {
  Group,
  type FileInput,
  type NumberInput,
  type Select,
  type TextInput,
} from '@mantine/core'
import type { DateInput } from '@mantine/dates'
import React from 'react'
import { themeCfg } from '../../theme/theme'

interface CustomProps
  extends Omit<
    React.ComponentPropsWithoutRef<
      | typeof Group
      | typeof TextInput
      | typeof FileInput
      | typeof NumberInput
      | typeof DateInput
      | typeof Select
    >,
    'onChange'
  > {
  w?: string | number
  label?: string
  labelh?: string
  placeholder?: string
  value?: any
  onChange?: (value: any) => void
  children: React.ReactNode | string
}

const AppInputWrapper: React.FC<CustomProps> = ({
  w = '100%',
  label,
  labelh,
  placeholder,
  value,
  onChange,
  children,
  ...props
}) => {
  return (
    <Group
      {...(props as React.ComponentPropsWithoutRef<typeof Group>)}
      w={w}
      align={label ? 'flex-end' : undefined}
      // bg={themeCfg?.debug ? 'yellow' : undefined}
      // align="flex-end"
      // align={label ? 'flex-end' : ''}
    >
      {children}
    </Group>
  )
}

export default AppInputWrapper
